import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { ESimpleDateKey } from '../../components/analytics/dates-list';

type TState = {
  selectedSimpleDateKey?: ESimpleDateKey;
  startDate?: string;
  endDate?: string;
  videosId?: string[];
  linkId?: string[];
  assetLinkId?: string[];
  userId?: string[];
  playlistId?: string[];
};

const initialState: TState = {
  selectedSimpleDateKey: ESimpleDateKey.DAY,
};

const filtersSlice = createSlice({
  name: 'analytics/filters',
  initialState: { ...initialState },
  reducers: {
    setDateFilterAction(
      state,
      action: PayloadAction<{
        key?: ESimpleDateKey;
        startDate?: string;
        endDate?: string;
      }>
    ) {
      state.selectedSimpleDateKey = action.payload.key;
      state.startDate = action.payload.startDate;
      state.endDate = action.payload.endDate;
    },
    setVideoFilterAction(state, action: PayloadAction<string[] | undefined>) {
      state.videosId = action.payload;
    },
    setLinkFilterAction(state, action: PayloadAction<string[] | undefined>) {
      state.linkId = action.payload;
    },
    setAssetLinkFilterAction(
      state,
      action: PayloadAction<string[] | undefined>
    ) {
      state.assetLinkId = action.payload;
    },
    setUserFilterAction(state, action: PayloadAction<string[] | undefined>) {
      state.userId = action.payload;
    },
    setPlaylistFilterAction(
      state,
      action: PayloadAction<string[] | undefined>
    ) {
      state.playlistId = action.payload;
    },
    resetFiltersAction(state) {
      state = { ...initialState };
    },
  },
});

export const {
  setAssetLinkFilterAction,
  setDateFilterAction,
  setLinkFilterAction,
  setPlaylistFilterAction,
  setUserFilterAction,
  setVideoFilterAction,
} = filtersSlice.actions;
export const analyticFiltersReducer = filtersSlice.reducer;
